import CardComp from 'developer-docs-shared-components/components/endpoint/CardComp';
import { jsx as _jsx } from "react/jsx-runtime";
const EndpointCard = ({
  children
}) => {
  return /*#__PURE__*/_jsx(CardComp, {
    children: children
  });
};
export default EndpointCard;